// assets/storefront-api.js

(function() {
  const config = window.__STOREFRONT_API_CONFIG__;
  if (!config) {
    console.warn('Storefront API config not found on window.__STOREFRONT_API_CONFIG__');
    return;
  }

  const endpoint = `https://${config.domain}/api/${config.apiVersion}/graphql.json`;

  async function storefrontFetch(query, variables = {}) {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.accessToken,
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    });

    if (!res.ok) {
      throw new Error(`Storefront API error: ${res.status} ${res.statusText}`);
    }

    const json = await res.json();

    if (json.errors) {
      console.error('Storefront GraphQL errors:', json.errors);
      // Choose how you want to handle these in your UI
      throw new Error('Storefront GraphQL returned errors');
    }

    return json.data;
  }

  // Expose a small client on window (or attach to a namespace)
  window.StorefrontGraphQL = {
    query: storefrontFetch,
  };
})();